import React, { useEffect, useMemo } from 'react';
import { useScreenSize } from '../../hooks/useScreenSize';
import { SanityArticleCategory } from '../../types/common';

type SimpleFilterProps = {
  categories: SanityArticleCategory[];
  filteredCategories: string[];
  onFilter: (categoryId: string) => void;
  onClearFilters: () => void;
}

export function SimpleFilter({ categories, filteredCategories, onFilter, onClearFilters }: SimpleFilterProps) {
  const { isMobile } = useScreenSize();

  useMemo(() => {
    if(typeof window !== "undefined") {
      const filter = new URLSearchParams(window.location.search).get('filter');

      if(filter) {
        onFilter(filter);
      }
    }
  }, []);

  return (
    <aside className='filters'>
      {!isMobile && (
        <div>
          <h3>Filters</h3>
          {filteredCategories.length > 0 && (
            <button className='clear' onClick={onClearFilters}>Clear all filters</button>
          )}
        </div>
      )}

      <div>
        {categories.map(tag => (
          <button
            key={tag._id}
            onClick={() => onFilter(tag._id)}
            className={`tag-button ${filteredCategories.includes(tag._id) && 'active'}`}
          >
            {tag.name}
            <span />
          </button>
        ))}
      </div>
      <p>Filter the information {isMobile && 'below '}using these tags</p>
    </aside>
  );
}
